{
    "cl_header": {
      "logout": "Disconnetti"
    },
    "cl_applauncher": {
      "seemoreapplications": "Guarda altre applicazioni",
      "spinner": "Caricamento...",
      "noApps": "Nessuna app disponibile"
    },
    "cl_alert": {
      "dismiss_all": "Ignora tutto",
      "notfication_title": "Notifiche",
      "no_notifications": "Nessuna notifica"
    },
    "cl_side_nav": {
      "support": "Supporto",
      "legal": "legali"
    },
    "cl_company_switcher": {
      "search_company": "Nome azienda",
      "loading": "caricamento"
    },
    "applauncher": {
      "spinner": "Caricamento..."
    }
  }